import { jsx as _jsx } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useEffect } from 'react';
import { useTracker } from '../tracking/useTracker';
import { Step } from '../views/Step';
import EmailClientButton from './EmailClientButton';
import { EmailClient, emailClientFromDomain, GMAIL_LINK, YAHOO_LINK } from './emailUtils';

const GoToMailButton = ({
  email
}) => {
  const stepKey = Step.Verification;
  const emailClient = emailClientFromDomain(email);
  const Tracker = useTracker();
  useEffect(() => {
    Tracker.signupInteraction(`verification-shown-go-to-${emailClient}`);
  });

  const getEmailClientLink = () => {
    let link = null;

    if (emailClient === EmailClient.Gmail) {
      link = GMAIL_LINK;
    } else if (emailClient === EmailClient.Yahoo) {
      link = YAHOO_LINK;
    }

    if (link) {
      Tracker.click({
        message: 'click go to mail',
        linkLocation: `verify email button - ${emailClient}`
      });
    }

    return link;
  };

  const handleGoToEmail = () => {
    const link = getEmailClientLink();

    if (link) {
      window.open(link, '_blank');
    }
  };

  if (!email || !emailClient) {
    return null;
  }

  return /*#__PURE__*/_jsx(EmailClientButton, {
    emailClient: emailClient,
    onClick: handleGoToEmail,
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `views.${stepKey}.goTo${emailClient}`
    })
  });
};

export default GoToMailButton;